import PropTypes from 'prop-types';
import React from 'react';

import styles from './StickerLabels.module.css';

const StickerLabels = ({ stickers = [] }) => {
  return (
    stickers &&
    stickers.length > 0 && (
      <div className={styles.stickerList}>
        {stickers.map((item) => {
          return (
            item?.label && (
              <div
                key={`sticker-${item?.label}`}
                className={`${styles.sticker} label`}
              >
                <div
                  className={styles.stickerDot}
                  style={{
                    backgroundColor: item?.dotColor || '#0075C9',
                  }}
                >
                  &nbsp;
                </div>{' '}
                {item?.label}
              </div>
            )
          );
        })}
      </div>
    )
  );
};

StickerLabels.propTypes = {
  stickers: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      dotColor: PropTypes.string,
    })
  ),
};

export default StickerLabels;
